module.exports = __webpack_public_path__ + "static/Boy@2x.0629f3a3.png";